(ns motorsaif.i18n
  (:require
   #?(:clj [clojure.java.io :as io])
   #?(:cljs [motorsaif.log :as log])
   #?(:cljs [reagent.core :as r])
   #?(:cljs [goog.string :refer [format]])
   [taoensso.encore :as encore]
   [motorsaif.data-utils :as du]
   [taoensso.tempura :as tempura]
   [motorsaif.i18n.ar :as ar]
   [motorsaif.i18n.en :as en]
   [motorsaif.i18n.ur :as ur]
   [clojure.string :as str])
  #?(:cljs (:require-macros [motorsaif.i18n])))


;; NOTE not clj ready yet

(def default-dict
  {:ar ar/dict
   :ur ur/dict
   :en en/dict})

(defn -keywordize [key-coll]
  (if (keyword? key-coll)
      key-coll
      (keyword (str/join "." (map #(subs (str %) 1) key-coll #_(concat [:forms :new-request] [:request :request/geo-location]))))))

(def keywordize (memoize -keywordize))

(def -tr (memoize tempura/tr))
(defonce *tr (atom nil))

(defn tr [& args]
  (apply @*tr args))

;; This is a cljc function. I need this to do what it does but be a macro. The macro will take its first arg and append it to a file.
;; The purpose is that this is my translation function and I need to collect all my translation keys on my frontend by compiling it
;; and grabbing all keys like this.
;; Would a macro solve this problem? Even if the macro is wrapped in other HOF functions
;; that concat the keys?



;; #?(:clj
;;    (do
;;      (def file-lock (Object.))
;;      (defmacro tr
;;        "Runtime behaviour: same as (apply @*tr args).
;;       Compile-time side-effect: append the first arg (the key) to
;;       resources/keys.edn (one key per line)."
;;        [& args]
;;        #_(when (seq args)
;;          (let [k (first args)]
;;            #?(:clj (locking file-lock
;;                      (spit "resources/keys.edn"
;;                            (str k "\n")
;;                            :append true)))))
;;        `(apply @*tr ~@args))


;;      (defmacro tr-scope
;;        "Macro that expands to an anonymous function.
;;       Every call to the returned function will expand the inner `tr` macro,
;;       so keys are still collected at compile-time."
;;        [scope]
;;        (let [scope-sym (gensym "scope__")]
;;          `(let [~scope-sym ~scope]        ; evaluate scope only once
;;             (fn -tr-scope#
;;               ([] (-tr-scope# nil))
;;               ([k#] (-tr-scope# k# nil))
;;               ([k# fallback#] (-tr-scope# k# nil fallback#))
;;               ([k# args# fallback#]
;;                (let [k#   (du/ensure-vec k#)
;;                      path# (vec (concat ~scope-sym k#))]
;;                  (tr path# fallback# args#)))))))

;;      ))

(defn tr-scope
  "Returns a function that prepends scope to the translation key/key path,
  allowing for more terse translation calls.

  Example, concats path to `:page.home.header`:
  (let [trs (tr-scope [:page.home])]
    (trs [:header \"Header\"])

  Incurs small performance penalty over calling `tr` directly with full key path. "
  [scope]
  (fn -tr-scope
    ([k]
     (-tr-scope k nil))
    ([k fallback]
     (-tr-scope k nil fallback))
    ([k args fallback]
     (let [k (du/ensure-vec k)
           path (vec (concat scope k))]
       (apply tr (remove nil? [path fallback args]))))))


(comment
  (tr [:time-ago.day] [1]))


(defn set-tr-fn! [*dict *locale]
  (reset! *tr
          (fn -tr-fn
            ([k] (-tr-fn k nil))
            ([k fallback]
             (-tr-fn k nil fallback))
            ([k args fallback]
             (let [k (keywordize (du/ensure-vec k))
                   path (-> [k]
                            (cond-> fallback
                              (conj fallback)))]
               (def zz path)
               (def rzz args)
               (try
                 (-tr
                  {:dict @*dict
                   :default-locale @*locale}
                  [@*locale :en] path args)
                 #?(:clj
                    (catch Error e
                      e))
                 #?(:cljs
                    (catch js/Error e
                      (log/error [:translation-error
                                  :e e
                                  :tr-path path
                                  :args args])))))))))



#?(:clj
   (let [*dict (atom default-dict)
         *locale (atom :en)]
     (set-tr-fn! *dict *locale)))

(comment
  (let [scoped (tr-scope [:forms.general]) ]
    (encore/qb 1e4
               (tr :forms.general/create)
               (tr [:forms.general/create])
               (scoped [:create])
               (tr [:malli :missing-key])
               )))
